document.addEventListener('turbolinks:load', function () {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('oauth') && urlParams.get('oauth') === 'bigcommerce') {
    $('#oauthBigcommerceModal').modal('show')
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.id === 'oauth-modal-trigger') {
        $('#oauthBigcommerceModal').modal('show')
      }
    },
    true
  )

  const bigcommerceTooltip = $('#bigcommerce-tooltip-container')

  if (localStorage.hideBigcommerceTooltip) {
    bigcommerceTooltip.remove()
  }
  $('#bigcommerce-tooltip-container .bigcommerce-tooltip__close').click(() => {
    bigcommerceTooltip.remove()
  })
  localStorage.setItem('hideBigcommerceTooltip', true)
})
